import CompanyOpenCloseForm from "Components/Form/CompanyOpenCloseForm";
import React from "react";
const daysList = [
  {
    name: "monday",
    placeHolder: "Monday",
    timingName: "monday",
  },
  {
    name: "tuesDay",
    placeHolder: "Tuesday",
    timingName: "tuesday",
  },
  {
    name: "wednesday",
    placeHolder: "Wednesday",
    timingName: "wednesday",
  },
  {
    name: "thursday",
    placeHolder: "Thursday",
    timingName: "thursday",
  },
  {
    name: "friday",
    placeHolder: "Friday",
    timingName: "friday",
  },
  {
    name: "saturday",
    placeHolder: "Saturday",
    timingName: "saturday",
  },
  {
    name: "sunday",
    placeHolder: "Sunday",
    timingName: "sunday",
  },
];
const OpeningAndClosingTime = () => {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Company Opening and Closing Time</h4>
              <h6>Timing with break hours</h6>
            </div>
          </div>
        </div>

        {daysList?.map((d, _id) => (
          <CompanyOpenCloseForm
            name={`companySettings[0].${d?.name}`}
            placeholder={d?.placeHolder}
            timingName={`companySettings[0].${d?.timingName}`}
            key={_id}
          />
        ))}
      </div>
    </div>
  );
};
export default OpeningAndClosingTime;
